import {
  AimOutlined,
  ApartmentOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  DollarCircleFilled,
  DollarOutlined,
  PieChartOutlined,
  ReconciliationOutlined,
  SettingFilled,
  StockOutlined,
} from '@ant-design/icons';
import React from 'react';

export const menus = () => {
  const menuCadastro = [
    {
      id: 1,
      icon: <StockOutlined />,
      name: 'Painel de Embarque',
      url: '/painel-embarque',
      permissoes_que_habilitam_menu: ['painel-embarque:show'],
    },
    {
      id: 2,
      icon: <BarChartOutlined />,
      name: 'Dashboard de Performance',
      breakLine: true,
      url: '/dashboard-performance',
      permissoes_que_habilitam_menu: [
        'dashboard-performance:aderencia-carregamento',
        'dashboard-performance:variacao-frete',
      ],
    },
    {
      id: 3,
      icon: <SettingFilled />,
      name: 'Parametrização',
      url: null,
      permissoes_que_habilitam_menu: [
        'cadastro-usuario:show',
        'cadastro-cliente:show',
      ],
      menus: [
        {
          id: 4,
          parent_id: 3,
          icon: null,
          name: 'Cadastro de usuário',
          url: '/usuarios',
          permissoes_que_habilitam_menu: ['cadastro-usuario:show'],
        },
        {
          id: 5,
          parent_id: 3,
          icon: null,
          name: 'Cadastro de cliente',
          url: '/clientes',
          permissoes_que_habilitam_menu: ['cadastro-cliente:show'],
        },
      ],
    },
    {
      id: 6,
      icon: <ReconciliationOutlined />,
      name: 'Demandas',
      url: '/demandas',
      permissoes_que_habilitam_menu: ['lotes:show'],
    },
    {
      id: 9,
      icon: <AimOutlined />,
      name: 'Mapa de Motoristas',
      url: '/mapa-gerenciamento',
      permissoes_que_habilitam_menu: ['mapa-gerenciamento:show'],
    },
    {
      id: 10,
      icon: <DollarCircleFilled />,
      name: 'Precificação',
      url: '/precificacao',
      permissoes_que_habilitam_menu: ['precificacao:show'],
    },
    {
      id: 14,
      icon: <PieChartOutlined />,
      name: 'Precificação 2',
      url: '/dash-precificacao',
      permissoes_que_habilitam_menu: ['dash-precificacao:show'],
    },
    {
      id: 13,
      icon: <ApartmentOutlined />,
      name: 'Grupo de Frotista',
      url: '/grupo-frotista',
      permissoes_que_habilitam_menu: ['grupo-frotista:show'],
    },
    {
      id: 11,
      icon: <AreaChartOutlined />,
      name: 'Relatórios',
      url: null,
      permissoes_que_habilitam_menu: ['relatorios-viagens:show'],
      menus: [
        {
          id: 12,
          parent_id: 6,
          icon: null,
          name: 'Viagens',
          url: '/relatorios-viagens',
          permissoes_que_habilitam_menu: ['relatorios-viagens:show'],
        },
      ],
    },
    {
      id: 15,
      icon: <DollarOutlined />,
      name: 'Cotações',
      url: '/cotacao',
      permissoes_que_habilitam_menu: ['cotacao:show'],
    },
    {
      id: 16,
      icon: <BarChartOutlined />,
      name: 'Dashboards',
      url: '/dashboards',
      // TODO: Implementar permissões corretas
      permissoes_que_habilitam_menu: ['cotacao:show'],
    },
  ];

  return menuCadastro;
};
